import { useDispatch } from "react-redux";
import { Button, Message } from "../../../BP2Components";
import IntlMessages from "../../../../util/IntlMessages";
import React from "react";
import { getDeep, READ_MAP } from "../../../../util/fieldMap";
import { tState } from "../../RenderDevEditForm";
import { editDevForm } from "../../../../services/api/Api";
import { useIntl } from "react-intl";
import { resetChangeFlag } from "../../../../appRedux/actions/DevForm";

type tRenderDevSaveButtonProps = {
   fid: string;
   activeTabId: string;
   elements: any[];
};

export const RenderDevSaveButton = ({ fid, activeTabId, elements }: tRenderDevSaveButtonProps) => {
   const intl = useIntl();
   const dispatch = useDispatch();
   const pickStateFromElement = (el: any) => {
      const out: Record<string, any> = {};
      (Object.keys(READ_MAP) as (keyof typeof READ_MAP)[]).forEach((key) => {
         const cfg = READ_MAP[key];
         if (!cfg?.path) return;
         const raw = getDeep(el, cfg.path);
         const val = cfg.parse ? cfg.parse(raw) : raw;
         if (val !== undefined) out[key as string] = val;
      });
      return out;
   };

   const squashAdvanced = (fields: tState) => {
      const { advansedSearch, advansedSearchId, seekingOut, ...rest } = fields;

      return {
         ...rest,
         advansedSearch: advansedSearch ? (advansedSearchId ?? "0") : false,
         seekingOut: mapSeekingOutValue(seekingOut),
      };
   };

   const SEEKING_OUT_MAP: Record<string, string> = {
      "1": "drop_down_list",
      "2": "search_drop_down_list",
      "3": "dedicated_list",
      "4": "search_text",
   };

   const mapSeekingOutValue = (value: unknown): unknown => {
      if (typeof value !== "string") return value;
      return SEEKING_OUT_MAP[value] ?? value;
   };

   const handleSave = async () => {
      if (!fid || !activeTabId) {
         Message.warning("Missing form ID or tab ID");
         return;
      }

      const items = (elements as any[])?.reduce(
         (acc, el) => {
            if (!el?.id) return acc;

            const raw = pickStateFromElement(el) as tState;
            acc[String(el.id)] = squashAdvanced(raw);
            return acc;
         },
         {} as Record<string, any>,
      );

      const payload = {
         fid: !isNaN(Number(fid)) ? Number(fid) : fid,
         tabs: [
            {
               id: String(activeTabId),
               items,
            },
         ],
      };
      Message.loading(intl.formatMessage({ id: "form.saving" }), 0);
      try {
         const result = await editDevForm(payload);
         Message.destroy();
         if (result.status === 200) {
            dispatch(resetChangeFlag());
            Message.success(intl.formatMessage({ id: "form.doneProcessing" }));
            window.location.reload();
         } else {
            Message.error(intl.formatMessage({ id: "form.errorWhileSaving" }));
         }
      } catch (e) {
         Message.destroy();
         Message.error(intl.formatMessage({ id: "form.errorWhileSaving" }));
      }
   };
   return (
      <div className="dev-info" style={{ padding: "0 20px 20px 20px" }}>
         <Button buttonType="primary" onClick={handleSave}>
            <IntlMessages id="devForm.saveChangesInDevForm" />
         </Button>
      </div>
   );
};

export default RenderDevSaveButton;
